<template>
  <aside class="pix-bank-notice" role="note">
    <p class="pix-bank-notice__title">Aviso do seu banco</p>
    <p class="pix-bank-notice__company">
      RL Negócios Digitais Ltda
      <span>CNPJ 35.180.826/0001-64</span>
    </p>
    <p class="pix-bank-notice__text">
      Alguns bancos mostram a mensagem “não transfira, pode ser golpe”.
      A gente não controla esse aviso: ele é automático do banco.
      O Pix é da empresa da Rifa365. Pode pagar com tranquilidade.
    </p>
  </aside>
</template>

<script>
export default {
  name: "PixBankNotice",
};
</script>

<style scoped>
.pix-bank-notice {
  margin: 0 0 2px;
  padding: 12px 14px;
  text-align: left;
  border-radius: 12px;
  background: #eef6ff;
  border: 1px solid #93c5fd;
  color: #1e3a5f;
}

.pix-bank-notice__title {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1d4ed8;
}

.pix-bank-notice__company {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: #0f2744;
}

.pix-bank-notice__company span {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: #1e40af;
}

.pix-bank-notice__text {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #1e3a5f;
}
</style>
